import type { EntityID } from '@wovin/core/applog'
import type { Accessor, Component } from 'solid-js'
import type { SortableBlockItem } from './SortableBlocks'
import { Logger } from 'besonders-logger'
import classNames from 'classnames'
import { createMemo, For, mapArray, untrack } from 'solid-js'
import { useBlk } from '../data/VMs/BlockVM'
import { useKidRelations } from '../ui/reactive'
import { SortableBlocks } from './SortableBlocks'
import { TreeItem } from './TreeItem'

const { WARN, LOG, DEBUG, VERBOSE, ERROR } = Logger.setup(Logger.DEBUG) // eslint-disable-line unused-imports/no-unused-vars
export const KidsAsTabs: Component<{
	blockID?: EntityID
	// specialRoot?: SpecialRoot
	// kidRelationIDs: Array<EntityID> | null
	// blockIDs?: Array<EntityID> | null
	disabled?: boolean
	class?: string
	items: readonly SortableBlockItem[]
}> = (props) => {
	DEBUG(`<KidsAsTabs> created`, untrack(() => ({ ...props })))
	/* onwa-tab-show={setActive} ref={tabGroupRef} */
	return (
		<wa-tab-group class={classNames(props.class, 'w-88% self-center p-2')}>
			<For each={props.items}>
				{(tabItem, index: Accessor<number>) => {
					const blockVM = useBlk(tabItem.blockID)
					const kidRelations = tabItem.blockID ? useKidRelations(tabItem.blockID) : undefined
					const kidsForThisTab = kidRelations
						? mapArray(kidRelations, (rel) => {
							const block = useBlk(rel.block)
							if (!block) WARN('rel refers to missing block', { block, rel })
							DEBUG(`<KidsAsTabs#${tabItem.blockID}.kidItemsFromRelations>`, { rel, blockID: tabItem.blockID, blockVM })
							return ({
								id: rel.en,
								relationID: rel.en,
								blockID: rel.block,
								// type: block?.type,
							}) satisfies SortableBlockItem
						})
						: () => undefined

					return (
						<>
							<wa-tab slot='nav' panel={blockVM.contentPlaintext}>{blockVM.contentPlaintext}</wa-tab>
							<wa-tab-panel name={blockVM.contentPlaintext}>
								<SortableBlocks
									class='rounded py-2 pr-1'
									blockID={tabItem.blockID}
									items={kidsForThisTab()}
								>
									{(item) => {
										DEBUG(`<BlockTree.item> :`, item)
										return <TreeItem {...item} />
									}}
								</SortableBlocks>
							</wa-tab-panel>
						</>
					)
				}}
			</For>
		</wa-tab-group>
	)
}
